const SkleniSamZacetek = () => import("@views/app/pro-forma-payment/pro-forma-payment-start.vue");
const Esign = () => import("@views/public/e-sign.vue");

// Guid regex
const regex = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;

export const webRoutes = [
    {
        name: "skleni_sam_home",
        path: "skleni-sam/:dobType?",
        redirect: { name: "skleni_sam_zacetek" },
        children: [
            {
                component: SkleniSamZacetek,
                name: "skleni_sam_zacetek",
                path: "zacetek"
            },
        ]
    },
    {
        component: Esign,
        name: "esign",
        path: "esign/:id"
    }
];